import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IGetViewerControlledVizThemeParams {
}

export class GetViewerControlledVizThemeRequest extends Request<IGetViewerControlledVizThemeParams, IResult> {
    constructor(params: IGetViewerControlledVizThemeParams) {
        super('getViewerControlledVizTheme', params);
    }
}
